import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { Sparkles } from 'lucide-react';

export const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  if (!user) return null;

  const handleLogout = () => {
    logout();
    navigate('/');
    toast.success('Logged out successfully');
  };

  return (
    <header className="border-b bg-white/80 backdrop-blur-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex justify-between items-center">
        <button onClick={() => navigate('/')} className="flex items-center gap-2">
          <Sparkles className="h-6 w-6 text-emerald-600" />
          <span className="font-bold text-xl">PepFactor USA</span>
        </button>
        <div className="flex items-center gap-4">
          {user.role === 'admin' && (
            <Button variant="ghost" onClick={() => navigate('/admin')} data-testid="nav-admin-btn">
              Admin
            </Button>
          )}
          {user.role === 'clinic_manager' && (
            <Button variant="ghost" onClick={() => navigate('/clinic-signup')} data-testid="nav-clinic-btn">
              My Clinic
            </Button>
          )}
          <Button variant="ghost" onClick={() => navigate('/provider')} data-testid="nav-provider-btn">
            For Clinics
          </Button>
          <Button variant="ghost" onClick={() => navigate('/progress')} data-testid="nav-progress-btn">
            Progress
          </Button>
          <Button variant="ghost" onClick={() => navigate('/plan')} data-testid="nav-plan-btn">
            Plan
          </Button>
          <Button variant="ghost" onClick={() => navigate('/book')} data-testid="nav-book-btn">
            Book Clinic
          </Button>
          <Button variant="ghost" onClick={() => navigate('/shop')} data-testid="nav-shop-btn">
            Shop
          </Button>
          <Button variant="ghost" onClick={() => navigate('/account')} data-testid="nav-account-btn">
            Account
          </Button>
          <Button variant="outline" onClick={handleLogout} data-testid="nav-logout-btn">
            Log Out
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
